import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NbFormService } from '@showye/nbweb-input/nb-form';
import { ShowyePageApiService, ShowyePageAuthService, ShowyePageUtilService } from '@showye/showye-page-base';
import { format } from 'date-fns';

@Component({
  templateUrl: './view.component.html',
  styleUrls: ['./task.scss'],
})
export class ViewTaskComponent implements OnInit, OnDestroy {
  constructor(
    private api: ShowyePageApiService,
    private coder: ShowyePageUtilService,
    private auth: ShowyePageAuthService,
    modalSrv: NzModalService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private formService: NbFormService,
    public msg: NzMessageService,
    public notify: NzNotificationService,
  ) {
    modalSrv.closeAll();
  }

  public route$: Subscription | null = null;

  downloadUrl = this.api.getDownloadUrl();
  uploadUrl = this.api.getUploadUrl();
  importUrl = this.api.getImportUrl();
  token: any = this.auth.token;
  pdfUrl = '../../../../assets/pdf/web/viewer.html?file=';

  id: any;
  tid: any;
  task: any = {};
  ticket: any = {};
  forms: any;
  formGroups: FormGroup = new FormGroup({});
  operations: any = [];
  users: any = [];
  index = 0;
  data: any = {};
  userMap: any = {};
  roleMap: any = {};

  isAuditInfo = 'none';
  isFormVisible = 'block';

  goBack(): void {
    this.location.back();
  }

  ngOnDestroy(): void {
    if (this.route$) {
      this.route$.unsubscribe();
    }
  }
  ngOnInit(): void {
    this.reloadUsers();
    this.reloadRoles();
    this.route$ = this.route.params.subscribe((params: Params) => {
      if (params.id) {
        this.id = +params.id;
        this.reloadTask();
      } else {
        this.msg.warning('请选择要处理的任务');
        this.location.back();
      }
    });
  }
  reloadUsers(): void {
    this.api.listUsers().subscribe((e) => {
      this.users = e.data;
      this.userMap = e.data.reduce((a: any, c: any) => ({ ...a, [c.id]: c }), {});
    });
  }
  reloadRoles(): void {
    this.api.listPositions().subscribe((e) => {
      this.roleMap = e.data.reduce((a: any, c: any) => ({ ...a, [c.id]: c }), {});
    });
  }
  getTaskStatus(): string {
    switch (this.task.status) {
      default:
        return '待处理';
      case 2:
        return '已完成';
      case 3:
        return '已驳回';
    }
  }

  meta: any;
  reloadTicket(): void {
    this.api.getFlowTicket(this.tid).subscribe((e) => {
      this.ticket = e.data;
      this.reloadMeta(e.data.processId);
      this.data = this.ticket.data;
      this.formService.reloadData(this.formGroups, this.forms, this.data);
      this.currentData = this.data && this.currentForm ? this.data[this.currentForm.code] : {};
    });
  }
  reloadMeta(pid: any): void {
    this.api.getProcessMeta(pid).subscribe((e) => {
      if (e.data?.options) {
        Object.keys(e.data.options).forEach((x: any) => {
          if (e.data.options[x]) {
            e.data.options[x] = e.data.options[x].reduce((a: any, c: any) => ({ ...a, [c.value]: c.label }), {});
          }
        });
      }
      if (e.data?.fields) {
        e.data.fields.forEach((x: any) => (x.code = x.path));
      }
      this.meta = e.data;
    });
  }
  explainMeta(field: any): any {
    // console.log('explain: ', this.ticket.data, field, this.meta.options);
    return this.formService.explainData(this.ticket.data[this.meta.code], field, this.meta.options);
  }
  printTask: any;
  metaId: any;
  reloadTask(): void {
    this.api.getFlowTask(this.id).subscribe((e) => {
      this.task = e.data;
      if (this.task.metaId) {
        this.metaId = this.task.metaId;
      }
      if (this.task.allowPrint) {
        this.printTask = this.api.getFlowTaskPrintUrl(this.task.id) + (this.token ? '?token=' + this.token : '');
      }
      if (this.task.lastTicketId) {
        this.tid = this.task.lastTicketId;
        this.reloadTicket();
        this.reloadForm();
        this.reloadOperations();
        this.reloadHistory();
      }
    });
  }
  assigner(): any {
    if (this.ticket.assignToId) {
      const st = this.users.filter((x: any) => x.id === this.ticket.assignToId);
      if (st && st.length > 0) {
        return st[0].name;
      }
    }
    return null;
  }
  reloadForm(): void {
    this.api.getFormByTicketId(this.tid).subscribe((e) => {
      // const fm = [...e.data, { displayName: '流转记录', code: '$history', fields: [] }];
      const fm = e.data;
      this.formGroups = this.formService.reloadForm(fm, this.data);
      this.index = 0;
      this.currentForm = fm[0];
      this.code = this.currentForm.code;
      this.currentData = this.data ? this.data[this.currentForm.code] : {};
      this.forms = fm;
    });
  }
  reloadOperations(): void {
    this.api.getEdgesByTicketId(this.tid).subscribe((e) => {
      this.operations = e.data;
    });
  }

  comment: any;
  sign: any;
  currentForm: any = {};
  code = '';
  currentData: any = {};

  get currentGroup(): FormGroup {
    return this.formGroups && this.formGroups.get(this.code) ? (this.formGroups.get(this.code) as FormGroup) : new FormGroup({});
  }
  changeIndex(id: any): void {
    this.data[this.currentForm.code] = this.currentGroup.value;
    this.currentForm = this.forms[id];
    this.code = this.currentForm.code;
    this.currentData = this.data[this.currentForm.code];
  }

  statusTag: any = {
    2: { text: '已处理', color: 'green' },
    1: { text: '等待处理', color: 'blue' },
    3: { text: '正常完结', color: 'gray' },
    4: { text: '异常完结', color: 'red' },
  };
  history: any = [];
  reloadHistory(): void {
    this.api.getHistoryByTicketId(this.tid).subscribe((e: any) => {
      this.history = e.data.sort((a: any, b: any) => b.id - a.id);
    });
  }

  downLoad = this.api.getDownloadUrl();

  showViewModal = false;
  ticketId: any;
  auditInfo: any;
  isViewNodeVisibleChange(ev: any): void {
    this.showViewModal = ev;
  }

  onNodeView(ev: any): void {
    if (ev.isCurrent && ev.taskStatus != 2 && ev.taskStatus != 3) {
    } else if (ev.operatorId == 0) {
    } else {
      this.ticketId = ev.id;
      this.showViewModal = true;
      this.auditInfo = ev;
    }
  }
}
